import { isNotDefined } from '@sgme/fp';
import { uniqBy } from 'lodash-es';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';
import type { Sales } from 'state/secondaryMarket/shared/referential/referential.model';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

import type { SalesDesk } from './cpOrder/referential/client/client.model';

const empty: readonly [] = [];
export function getAvailableDesks(allSales: ReadonlyArray<Sales> | undefined) {
  if (allSales === undefined) {
    return empty;
  }
  const result = uniqBy(allSales, 'desk').map(s => ({ desk: s.desk }) as SalesDesk);
  return result;
}

export function getAvailableSalesWithSelecteDesk(
  allSales: ReadonlyArray<Sales> | undefined,
  selectedSalesDesk: string | undefined,
) {
  if (allSales === undefined || selectedSalesDesk === undefined) {
    return [];
  }
  const allSalesPersonWithDesk = allSales.filter(sales => sales.desk === selectedSalesDesk);
  return uniqBy(allSalesPersonWithDesk, 'id');
}

export function formatByPriceType(price: number | undefined, priceType: SecondaryPriceType | undefined) {
  if (price === undefined) {
    return price;
  }
  return priceType === 'Percent' ? price * 100.0 : price;
}

export function toBcsProductKey(key: string): BcsProductKey | undefined {
  if (isNotDefined(key)) {
    return undefined;
  }
  const parts = key.split(':');
  if (parts.length === 3) {
    return {
      source: parts[0],
      subType: parts[1],
      code: parts[2],
    } as BcsProductKey;
  }
}

export function bcsProductKeyToString(key?: BcsProductKey) {
  return `${key?.source ?? ''}:${key?.subType ?? ''}:${key?.code ?? ''}`;
}
export const getKeyCode = (key: string): string | undefined => toBcsProductKey(key)?.code;
export const getXoneKeyCode = (key: string): string | undefined =>
  `${toBcsProductKey(key)?.subType}-${toBcsProductKey(key)?.code}`;
